/* istanbul ignore file */
import { Routes } from 'react-router-dom';
import { Page404 } from 'framework/statusPages';
import useAuthenticationService from 'infrastructure/security/authentication/authenticationService';
import { GlobalProtectedRoute } from 'framework/authorization';
import { Route } from 'framework/routing';
import WorkingHoursList from 'domain/finance/workingHours/List';
import { ProtectedRouter } from 'infrastructure/routing';
import { getWorkingHoursListUrl, getWorkingHoursRouterPath, useWorkingHoursRoute } from './route';
import { READ_WORKING_HOURS_REPORT } from 'domain/finance/workingHours/shared/workingHoursService';

const WorkingHoursRouter = () => {
  const { isAuthenticated } = useAuthenticationService();
  const { listRoute } = useWorkingHoursRoute();

  return (
    <ProtectedRouter basePath={getWorkingHoursListUrl()}>
      <Routes>
        <Route
          path={listRoute}
          element={
            <GlobalProtectedRoute globalPermissionToCheck={READ_WORKING_HOURS_REPORT}>
              <WorkingHoursList />
            </GlobalProtectedRoute>
          }
        />

        <Route path="*" element={<Page404 isAuthenticated={isAuthenticated} />} />
      </Routes>
    </ProtectedRouter>
  );
};

WorkingHoursRouter.getRouterPath = getWorkingHoursRouterPath;

export default WorkingHoursRouter;
